import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-apps",
  "use": "icon-soc-apps-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-apps\">\r\n<g transform=\"translate(-176.128 -176.128) scale(1.344000)\">\r\n<path d=\"M192 192h240v240H192V192zm400 0h240v240H592V192zM192 592h240v240H192V592zm400 0h240v240H592V592z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-apps.svg
// module id = u4i+
// module chunks = 410